import ContextWrapper from './context/ContextWrapper';
import { setupI18next } from './i18n/i18next';
import translationsEnGB from './i18n/translations/en-GB.json';
import './styles/variables.scss';
import Menu from './components/menu/menu';

const translations = {
  'en-GB': { translation: translationsEnGB }
};

setupI18next(translations);
function App() {
  return (
    <>
      <ContextWrapper>
        <Menu />
      </ContextWrapper>
    </>
  );
}

export default App;
